import React, { Component } from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros'

export default class PublicacionListItem extends Component {
    render = () => {
        const {
            idPublicacion,
            titulo,
            skuSeller,
            skuMarket,
            categoria,
            precioLista,
            precioPromocional,
            estado,
            img,
            marca,
            envioGratis,
            handleEstado,
            tipoEntrega,
            fechaPublicacion,
            descripcionSeller,
            tipoPublicacion,
            stock,
            isAdminOrCategory,
            productoExceptuado
        } = this.props;

        const switchClassEstado = () => {
            switch (estado) {
                case "activo":
                    return "label label-item label-success";
                case "pendiente_activacion":
                    return "label label-item label-grey";
                case "pausado":
                    return "label label-item label-red";
                case "en_revision":
                    return "label label-item label-primary";
                default:
                    return "label label-item";
            }
        }

        const switchLabelEstado = () => {
            switch (estado) {
                case "activo":
                    return "ACTIVO";
                case "pendiente_activacion":
                    return "PENDIENTE";
                case "pausado":
                    return "PAUSADO";
                case "en_revision":
                    return "EN REVISIÓN";
                default:
                    return estado;
            }
        }

        let labelEstado =
            <div className="col-4 col-md-1">
                <span className={switchClassEstado()}>{switchLabelEstado()}</span>
            </div>
        ;

        let checkboxEstado =
            <div
                className="custom-control form-switch"
                onClick={(e) => handleEstado(e, { idPublicacion: idPublicacion, estado: estado, skuSeller: skuSeller, stock: stock })}
            >
                <input
                    id={idPublicacion}
                    type="checkbox"
                    className="form-check-input"
                    defaultChecked={estado === "activo"}
                />
                <label htmlFor={idPublicacion} className="custom-control-label text-capitalize d-block">
                    <span className={switchClassEstado()}>{switchLabelEstado()}</span>
                </label>
            </div>
        ;

        let switchEstado = () => {
            switch (estado) {
                case "activo":
                case "pendiente_activacion":
                case "pausado":
                case "en_revision":
                    return (isAdminOrCategory) ? checkboxEstado : labelEstado;
                default:
                    return estado
            }
        }


        return (
            <div className="list-group-item hover-background-color bg-white border border-3 border-light">
                <div className="row p-2 align-items-center">

                    <div className="col-8 col-md-2 text-center text-break">
                        <div className="displayInlineTable">
                            <h6 className="font-weight-bold">{descripcionSeller}</h6>
                            <span className="font-size-072rem">{fechaPublicacion.substr(0, 10)}</span>
                            <br></br><span className="font-size-072rem">{idPublicacion}</span>
                        </div>
                    </div>

                    <div className="col-4 col-md-1 text-center">
                        <img className="mw-60px" alt={titulo.substring(0, 10) + "..."} src={img} />
                    </div>

                    <div className="col-12 col-md-9 p-md-0 p-4">
                        <div className="row px-1">

                            <div className="col-12">
                                <h6 className="box-title m-b-5 font-weight-bold">{titulo}</h6>
                            </div>

                            <div className="col-12 col-md-6 pb-lg-0 pb-md-0 pb-4">
                                <small className="applyFont">{marca} - {categoria}</small>
                                <small className="d-block mt-1">
                                    SKU Seller: {skuSeller} | SKU Market: {skuMarket}
                                </small>
                                <small className="d-block mt-1">
                                    <b>Tipo publicación: </b>{tipoPublicacion}
                                </small>
                                <small className="d-block mt-1">
                                    <b>Stock: </b>{stock}
                                </small>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                <small className="font-14 applyFont">
                                    {tipoEntrega?.descripcion ?? ""}
                                </small>
                                <br />
                                <small className="font-14 applyFont">
                                    {(envioGratis) ? "Envio Gratis" : ""}
                                </small>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                <h6 className="font-weight-bold box-title m-b-0">
                                    $ {(precioPromocional) ? formatoDecimal(precioPromocional) : formatoDecimal(precioLista)}
                                </h6>
                                <small className="font-size-10px">Precio Publicado</small>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                {switchEstado()}
                                {isAdminOrCategory && productoExceptuado &&
                                    <small className="label label-item label-red mt-1 p-1">
                                        PRODUCTO <br /> EXCEPTUADO
                                    </small>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}